import { httpClient } from '@/core/api/httpClient';
import { API_V1 } from '@/core/api/endpoints';

export async function downloadFile(storageKey: string, filename: string): Promise<void> {
  const { data } = await httpClient.get<Blob>(`${API_V1}/files/${storageKey}`, {
    responseType: 'blob',
  });

  const url = URL.createObjectURL(data);
  const anchor = document.createElement('a');
  anchor.href = url;
  anchor.download = filename;
  anchor.click();
  URL.revokeObjectURL(url);
}

/**
 * Fetches a file as a Blob from the storage backend.
 * Intended for in-browser preview — callers are responsible for revoking
 * any ObjectURL created from the returned Blob.
 */
export async function fetchFileBlob(storageKey: string, signal?: AbortSignal): Promise<Blob> {
  const { data } = await httpClient.get<Blob>(`${API_V1}/files/${storageKey}`, {
    responseType: 'blob',
    signal,
  });
  return data;
}
